import { useMutation, useQueryClient } from "@tanstack/react-query";
import sDocumentAxios from "../../../../services/department-viags/statistic-documents.service";

interface Variables {
  departmentId: number;
  info: string;
}

const update = (params: Variables) => {
  const url = `/viagsemployee/update-info-extras/${params.departmentId}`;
  return sDocumentAxios.post(url, `"${params.info}"`);
};

export const useUpdateInfoExtras = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (variables: Variables) => update(variables),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ["viags-departments"] });
  };

  return { ...mutation, invalidate };
};
